module.exports = __webpack_public_path__ + "static/front1-36cb76afa1562ceb44098bf943133bd9.png";